import React from 'react'
import withStyles from 'react-jss'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Button from '../../button'
import { StateConsumer } from '../../player/state'
import { clearAdOnPause } from '../utils'

const styles = theme => {
  return {
    header: {
      top: 0,
      position: 'absolute',
      color: theme.color.white,
      textShadow: theme.shadow.textShadow(theme.color.black).primary,
      width: '100%',
      height: 64,
      textAlign: 'center',
      display: 'block',
      opacity: 0
    },

    title: {
      display: 'inline-block',
      zIndex: theme.zIndex.overlay,
      position: 'relative',
      lineHeight: 4.5
    },

    closeButton: {
      display: 'inline-block',
      zIndex: theme.zIndex.overlay,
      right: 0,
      top: 14,
      position: 'fixed',
      marginRight: 20,
      cursor: 'pointer',
      maxWidth: 140,
      backgroundImage: `linear-gradient(rgba(91, 91, 91, 0.2), rgba(91, 91, 91, 0.2)),
        linear-gradient(156.52deg, rgba(255, 255, 255, 0.2) 2.12%, rgba(255, 255, 255, 0.0001) 39%, rgba(255, 255, 255, 0.0001) 54.33%, rgba(255, 255, 255, 0.05) 93.02%)`
    },

    show: {
      opacity: 1
    }
  }
}

class AdOnPauseHeader extends React.PureComponent {
  render() {
    const { classes, setIsAdOnPauseShown } = this.props

    const onClickHandler = () => {
      clearAdOnPause()
      setIsAdOnPauseShown(false)
    }

    return (
      <StateConsumer>
        {({
          isAdOnPauseShown
        }) => {
          return (
            <div
              className={classnames(classes.header, {
                [classes.show]: isAdOnPauseShown
              })}
            >
              <div className={classes.title}>Sponsored Content</div>
              <Button
                className={classes.closeButton}
                onClick={() => { onClickHandler() }}
                text="CLOSE AD"
                darkBGSecondary
              />
            </div>
          )
        }}
      </StateConsumer>
    )
  }
}

AdOnPauseHeader.propTypes = {
  setIsAdOnPauseShown: PropTypes.func.isRequired
}

export default withStyles(styles)(AdOnPauseHeader)
